module.exports = __webpack_public_path__ + "img/playbutton28.8fdade9b.png";